module.exports = __webpack_public_path__ + "media/images/policies/step1-edde384a3357e6de5b5d944c586133c1.svg";